import { AccessorsMutatorsDecorator } from '../../helpers';
import { TranslatableModel } from './translatable-model';
import { AddonSetting } from "./addon-setting.model";

/**
 * @class Coupon
 * @property {number} id
 */
export class Coupon extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [
            'name',
        ];
    }

    static get FLAT_DISCOUNT_TYPE() {

        return {
            key: 1,
            value: 'FLAT',
        };
    }

    static get PERCENTAGE_DISCOUNT_TYPE() {

        return {
            key: 2,
            value: 'PERCENTAGE',
        };
    }

    static get DISCOUNT_TYPES() {

        return [
            this.FLAT_DISCOUNT_TYPE,
            this.PERCENTAGE_DISCOUNT_TYPE,
        ];
    }

    static get ONE_TIME_REDEMPTION() {

        return {
            key: 1,
            value: 'ONE_TIME',
        };
    }

    static get FOREVER_REDEMPTION() {

        return {
            key: 2,
            value: 'FOREVER',
        };
    }

    static get LIMITED_REDEMPTION() {

        return {
            key: 3,
            value: 'LIMITED_NUMBER_OF_TIMES',
        };
    }

    static get REDEMPTION_TYPES() {

        return [
            this.ONE_TIME_REDEMPTION,
            this.FOREVER_REDEMPTION,
            this.LIMITED_REDEMPTION,
        ];
    }

    fill(...params) {

        super.fill(...params);

        this.setDefaults();
    }

    setDefaults() {

        if (angular.isUndefined(this.subscription_addons)) {

            this.subscription_addons = [];
        }

        if(this.expiration_date == null) {

            this.expiration_date = null;
        }

        if (this.expiration_date !== null && !(this.expiration_date instanceof Date)) {

            this.expiration_date = new Date(this.expiration_date);
        }

        if (angular.isUndefined(this.status)) {

            this.status = 1;
        }

        if (angular.isUndefined(this.discount_type)) {

            this.discount_type = this.constructor.FLAT_DISCOUNT_TYPE.key;
        }

        if (angular.isUndefined(this.redemption_type)) {

            this.redemption_type = this.constructor.ONE_TIME_REDEMPTION.key;
        }
    }

    formatRedemptionType(value = this.redemption_type) {

        return this.constructor.REDEMPTION_TYPES.find(({key}) => key === value).value;
    }

    setSubscriptionAddons(value = []) {

        return value.map(addon => addon instanceof AddonSetting ? addon : new AddonSetting(addon));
    }
}

AccessorsMutatorsDecorator(
    'id',
    ...Coupon.translatableAttributesWithLanguageAliases,
    'status',
    'discount_amount',
    'discount_type',
    'redemption_type',
    'number_of_times',
    'expiration_date',
    'maximum_redemption',
    'created_at',
    'user_id',
    'user_name',
    'subscription_addons',
    'addon_list_en',
    'addon_list_ar',
    'creator_username',
    'unique_id',
)(Coupon);



// WEBPACK FOOTER //
// ./src/pms-api/models/coupon.model.js